import { JourneySchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/journeys/{journeyId} — lifecycle marketing-automation
 * definitions (growth-engine Phase 1). Read + write by owner|manager
 * (infra/firestore.rules — mirrors customerSegments; the daily runner + the
 * bootstrap seed use the admin SDK, which bypasses rules).
 *
 * Definitions ship SEEDED-but-inactive (`active: false`); this operator surface
 * (`/marketing/journeys`) is what flips them on and tunes their steps. The
 * runner (`marketingJourneysDaily`) skips inactive journeys, so an untouched
 * journey costs nothing.
 *
 * `set()` re-validates the whole object against `JourneySchema` and persists the
 * caller's original object (Timestamps intact — see `_base.ts`). The editor
 * builds a full, schema-valid journey before calling `set()`; the enable/disable
 * toggle uses `update()` to patch `active` + `updatedAt` only.
 */
export function journeysRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/journeys`,
    schema: JourneySchema,
    name: `tenants/${tenantId}/journeys`,
  });
}
